export const numberFormat = (number: number) => {
  return new Intl.NumberFormat('ru-RU').format(number);
};
